import React from "react";
import styles from "./styles.module.scss";

type Piece = {
  src: string;
  alt: string;
  left: number;
  top: number;
  width: number;
  z: number;
  float?: boolean;
  delay?: number;
};

const BASE = "/images-capa2/comunidade";

const PIECES: Piece[] = [
  { src: "card-parceiros.png", alt: "+ de 10 mil parceiros", left: 7.41, top: 17.59, width: 21.96, z: 1 },
  { src: "card-suporte.png", alt: "Suporte por e-mail e whatsapp", left: 73.57, top: 20.19, width: 27.05, z: 2 },
  { src: "card-relatorios.png", alt: "Relatórios personalizados", left: 49.91, top: 34.26, width: 31.7, z: 3 },
  { src: "card-visao.png", alt: "Visão de dados em tempo real", left: 92.54, top: 16.67, width: 21.96, z: 4 },
  { src: "fl-pizza.png", alt: "Pedidos por seguradora", left: 25.18, top: 72.41, width: 24.2, z: 5, float: true, delay: 0 },
  { src: "card-comissao.png", alt: "+ de R$50 milhões distribuídos em comissão", left: 26.25, top: 28.15, width: 27.05, z: 6 },
  { src: "fl-linha.png", alt: "Total de vendas", left: 8.48, top: 49.17, width: 24.2, z: 7, float: true, delay: 0.6 },
  { src: "mockup.png", alt: "Painel Parceiros Promo", left: 50.67, top: 69.81, width: 47.23, z: 8 },
  { src: "fl-valor.png", alt: "Valor em vendas aprovadas", left: 75.4, top: 85.56, width: 21.07, z: 9, float: true, delay: 0.9 },
  { src: "fl-acessos.png", alt: "Total de acessos do mês", left: 78.88, top: 62.87, width: 28.93, z: 10, float: true, delay: 0.3 },
  { src: "badge-aviao.png", alt: "", left: 27.37, top: 94.07, width: 4.46, z: 11, float: true, delay: 1.2 },
  { src: "badge-escudo.png", alt: "", left: 88.66, top: 79.81, width: 5.0, z: 12, float: true, delay: 0.4 },
];

const ComunidadeV2: React.FC = () => {
  return (
    <section className={styles.comunidade}>
      <h2>
        <strong>Comunidade Parceiros Promo:</strong> toda tecnologia e suporte
        para aumentar sua renda!
      </h2>

      <div className={styles.scene}>
        {PIECES.map((p) => (
          <div
            key={p.src}
            className={styles.piece}
            style={{ left: `${p.left}%`, top: `${p.top}%`, width: `${p.width}%`, zIndex: p.z }}
          >
            <img
              src={`${BASE}/${p.src}`}
              alt={p.alt}
              aria-hidden={p.alt === "" ? true : undefined}
              className={p.float ? styles.float : undefined}
              style={p.float && p.delay ? { animationDelay: `${p.delay}s` } : undefined}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default ComunidadeV2;
